import { withFieldGroup } from '@massilia/features'
import { Button } from '@massilia/ui'
import { Loader2, Tag, X } from 'lucide-react'

import type { CheckoutFormValues } from '../checkout-form.schema'

interface CheckoutPromoCodeSlotProps {
  appliedCode: null | string
  isVerifying: boolean
  onRemove: () => void
  onVerify: (code: string) => void
  promoCodeDiscount: null | number
  promoCodeError: null | string
}

export const CheckoutPromoCodeSlot = withFieldGroup({
  defaultValues: {} as Pick<CheckoutFormValues, 'promoCode'>,
  props: {} as CheckoutPromoCodeSlotProps,
  render: function CheckoutPromoCodeFields({
    appliedCode,
    group,
    isVerifying,
    onRemove,
    onVerify,
    promoCodeDiscount,
    promoCodeError,
  }) {
    if (appliedCode && promoCodeDiscount) {
      return (
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2">
            <Tag className="text-success-600 h-3.5 w-3.5" />
            <span className="text-success-600 text-sm font-medium">
              {appliedCode.toUpperCase()}
            </span>
            <button
              className="text-gray-light-500 hover:text-gray-light-700 transition-colors"
              onClick={onRemove}
              type="button"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
          <span className="text-success-600 text-sm font-medium">- {promoCodeDiscount} &euro;</span>
        </div>
      )
    }

    return (
      <div className="flex w-full flex-col gap-1.5">
        <div className="flex flex-row items-center gap-2">
          <group.AppField name="promoCode">
            {(field) => <field.TextField containerClassName="flex-1" placeholder="Code promo" />}
          </group.AppField>
          <group.Subscribe selector={(state) => state.values.promoCode}>
            {(promoCode) => (
              <Button
                className="mt-2"
                disabled={isVerifying || !(promoCode ?? '').trim()}
                onClick={() => onVerify(promoCode ?? '')}
                type="button"
                variant="outline"
              >
                {isVerifying ? (
                  <Loader2 className="h-3.5 w-3.5 animate-spin" />
                ) : (
                  <span className="text-xs font-medium">Appliquer</span>
                )}
              </Button>
            )}
          </group.Subscribe>
        </div>
        {promoCodeError && (
          <p className="text-error-600 text-xs font-medium">{promoCodeError}</p>
        )}
      </div>
    )
  },
})
